import { Button, Paper } from "@mui/material";
import { Theme247 } from "../../../styles/Theme247";
import { makeStyles } from "tss-react/mui";
import { ReactComponent as CheckList } from "../../../assets/checklist.svg";

import { ReactComponent as FactoryIcon } from "../../../assets/industry_initial.svg";
import { ReactComponent as MachineIcon } from "../../../assets/machine_initial.svg";
import { ReactComponent as UserGroupInitial } from "../../../assets/user_group_initial.svg";


import i18n from "../../../reducers/i18n";
import { connect } from "react-redux";
import ActionCardWithIcon from "./ActionCardWithIcon";
import { Add, InfoRounded } from "@mui/icons-material";
import { useNavigate } from "react-router";
import { Link } from "react-router-dom";

export default connect(({ userProfile }) => ({ userProfile }), {})(props => {

    const navigate = useNavigate();
    const givenName = String(props.userProfile?.user?.givenname || "").trim();
    const surName = String(props.userProfile?.user?.surname || "").trim();
    const fullName = [givenName, surName].filter(Boolean).join(" ").trim();
    const initialStateTitle = fullName
        ? i18n().dashboard_initial_state_title.replace("%s", fullName)
        : i18n().dashboard_initial_state_title.replace(", %s", "");

    const useStyles = makeStyles()((theme) => ({
        elevatedSection: {
            ...Theme247.elevatedSection
        },
    }))

    const { classes } = useStyles();

    return (
        <Paper
            elevation={Theme247.elevationLow}
            className={classes.elevatedSection}
        >
            <div className="dashboardInitialState">
                <div className="title"> Dashboard</div>
                <div className="contentWrapper">
                    <div className="svg"><CheckList /></div>
                    <div className="_title" dangerouslySetInnerHTML={{ __html: initialStateTitle }}></div>
                    <div className="_description">{i18n().dashboard_initial_state_description}</div>
                </div>

                <div className="actionButtonWrapper">
                    <ActionCardWithIcon svg={<FactoryIcon />}  tooltip="Definieren Sie ihre lokale Struktur aus Werken und Bereichen" text={i18n().dashboard_initial_factory_title} button={<Button variant="contained" startIcon={<Add />} onClick={() => { navigate("/create-site") }}>NEU</Button>} />
                    <ActionCardWithIcon svg={<MachineIcon />} tooltip="Definieren Sie ihre logische Struktur aus Pools" text={i18n().dashboard_initial_equipment_title} button={<Button variant="contained" startIcon={<Add />} onClick={() => { navigate("/create-equipment-pool") }}>NEU</Button>} />
                    <ActionCardWithIcon svg={<UserGroupInitial />} tooltip="Fügen Sie weitere Nutzer hinzu" text={i18n().dashboard_initial_users_title} button={<Link to="/add-user"  state={{ pageType: "add" }}><Button variant="contained" startIcon={<Add />}> NEU</Button></Link>} />
                    <ActionCardWithIcon svg={<MachineIcon />} tooltip="Equipments können Sie erst anleegen, wenn Sie mindestens ein Werk/Bereich oder ein Pool angelegt haben, welchem das Equipment zugeordnet wird." text={i18n().dashboard_initial_final_title} button={<Link to="/create-equipment"  state={{ pageType: "add" }}><Button variant="contained" startIcon={<Add />} disabled={props.disableEquipmentButton}> NEU</Button></Link>} />
                </div>
            </div>
        </Paper>
    );
})
